import { useMemo } from "react";
import { useEtatGlobal } from "../EtatGlobal.js";

export const NIVEAU_LABEL = { 1: "Numérisation & Dépôt", 2: "Pré-compta", 3: "Révision" };

function parseDate(value) {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d) ? null : d;
}

export function daysUntil(due) {
  if (!due) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(due);
  target.setHours(0, 0, 0, 0);
  return Math.round((target - today) / 86400000);
}

// Dérive, pour le profil Comptable, une file de priorité et un récap à
// partir des VRAIES données déjà chargées globalement (todos uniquement —
// pas de Traitements comptables ici, voir analyse validée avec Jonathan) —
// pas de nouvel appel réseau, pas de donnée inventée.
function useBureauFeed() {
  const { utilisateur, todos } = useEtatGlobal();

  const myTodos = useMemo(() => {
    const myKey = `${utilisateur?.name || ""} ${utilisateur?.lastName || ""}`.trim();
    const mine = todos.find((block) => block.userKey === myKey);
    return (mine?.todos || []).filter(
      (t) => t.status !== "Terminer" && t.status !== "Archiver"
    );
  }, [todos, utilisateur]);

  // "Ma file de priorité" : mes todos ouverts, triés par échéance.
  const feed = useMemo(() => {
    const dueRank = (d) => (d ? d.getTime() : Infinity);
    return myTodos
      .map((t) => ({
        id: `todo-${t.id}`,
        kind: "task",
        todoId: t.id,
        client: t.nomClient || "",
        title: t.title,
        detail: t.commentaire || t.nature || "",
        due: parseDate(t.dueDate),
        priority: t.priority,
      }))
      .sort((a, b) => dueRank(a.due) - dueRank(b.due));
  }, [myTodos]);

  // "Récap" : mes todos "En cours" ou en retard uniquement (exclut par ex.
  // "Annuler") — sous-ensemble de myTodos, même forme que feed pour pouvoir
  // rouvrir ToDo.js directement au clic (kind: "task").
  const enCoursItems = useMemo(() => {
    const dueRank = (d) => (d ? d.getTime() : Infinity);
    return myTodos
      .filter((t) => {
        const due = parseDate(t.dueDate);
        const late = due !== null && daysUntil(due) < 0;
        return t.status === "En cours" || late;
      })
      .map((t) => ({
        id: `todo-${t.id}`,
        kind: "task",
        todoId: t.id,
        client: t.nomClient || "",
        title: t.title,
        due: parseDate(t.dueDate),
      }))
      .sort((a, b) => dueRank(a.due) - dueRank(b.due));
  }, [myTodos]);

  return { feed, enCoursItems };
}

export default useBureauFeed;
